import { createContext, useContext } from 'react'

// Shared between the ToastProvider component and the useToast hook, so the
// provider file only exports components and this file only exports hooks.
export const ToastContext = createContext(null)

export const TOAST_KINDS = {
  info: 'info',
  success: 'success',
  error: 'error',
}

export function useToast() {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used within a ToastProvider')
  return ctx
}